import produce from 'immer'

import { AUTH, PROFILE } from 'store/actions/types'

const initialState = {
    access_token: null,
    expires_at: null,
    loading: false,
    error: null,
    message: null
}

export default function authReducer(state = initialState, action) {
    const { type, payload } = action
    switch (type) {
        case AUTH.SIGNIN_USER:
        case PROFILE.PUT_PROFILE:
        case PROFILE.CHANGE_PROFILE:
        case PROFILE.RESET_PASSWORD:
            return produce(state, (draft) => {
                draft.loading = true
            })

        case AUTH.SIGNIN_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.loading = false
                draft.error = null
                if (payload) {
                    draft.access_token = payload.access_token
                    draft.expires_at = payload.expires_at
                }
            })

        case AUTH.SIGNIN_USER_FAIL:
        case PROFILE.PUT_PROFILE_FAIL:
        case PROFILE.CHANGE_PROFILE_FAIL:
        case PROFILE.SEND_RESET_LINK_FAIL:
        case PROFILE.RESET_PASSWORD_FAIL:
            return produce(state, (draft) => {
                draft.loading = false

                if (payload) {
                    if (payload.message) {
                        draft.error = payload.message
                    }

                    if (Array.isArray(payload) && payload.length) {
                        draft.error = payload.join(' ')
                    }
                }
            })

        case PROFILE.PUT_PROFILE_SUCCESS:
        case PROFILE.CHANGE_PROFILE_SUCCESS:
        case PROFILE.SEND_RESET_LINK_SUCCESS:
        case PROFILE.RESET_PASSWORD_SUCCESS:
            return produce(state, (draft) => {
                draft.loading = false
                if (payload && payload.message) {
                    draft.message = payload.message
                }
            })

        case AUTH.SIGNOUT_USER_SUCCESS:
            return produce(state, (draft) => {
                draft.loading = false
                draft.access_token = null
                draft.expires_at = null
            })

        case AUTH.CLEAR_ALERT:
            return produce(state, (draft) => {
                draft.message = null
                draft.error = null
            })

        default:
            return state
    }
}
